import { Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild } from '@angular/core';

@Component({
    selector: 'list-tooltip',
    templateUrl: './list-tooltip.component.html',
    styleUrls: ['./list-tooltip.component.scss'],
})
export class ListTooltipComponent implements OnInit {

    @Input('data') data: string[];
    public Data: string;
    @Input() Position: 'top' | 'bottom' | 'left' | 'right' = 'bottom';

    @ViewChild('trigger') triggerRef!: ElementRef<HTMLElement>;
    @ViewChild('tooltip') tooltipRef!: ElementRef<HTMLElement>;

    IsVisible = false;
    ArrowStyle: any = {};
    ContentStyle: any = {};

    constructor(private renderer: Renderer2) { }

    ngOnInit() {
        this.Data = this.data?.length > 0 ? this.data.join(", ") : '';
    }

    ShowTooltip() {

        if (!this.Data.length) return;

        this.IsVisible = true;

        this.UpdatePosition();
        // Pequeno delay para garantir renderização antes de mostrar
        const t = setTimeout(() => {
            clearTimeout(t);
            const el = this.tooltipRef?.nativeElement;
            if (el) {
                // Portal: mover para <body> para escapar a overflow/containing-block dos ancestrais
                if (el.parentElement !== document.body) document.body.appendChild(el);
                this.UpdatePosition();
                this.renderer.addClass(el, 'visible');
            }
        }, 10);
    }

    HideTooltip() {
        if (this.tooltipRef?.nativeElement) {
            this.renderer.removeClass(this.tooltipRef.nativeElement, 'visible');
        }
        const t = setTimeout(() => {
            clearTimeout(t);
            this.IsVisible = false;
        }, 200); // sincronizado com transition
    }

    // Popup em position:fixed posicionado a partir do rect do trigger — escapa a
    // qualquer overflow/stacking dos ancestrais (toolbars, ion-segment, etc.).
    @HostListener('window:scroll')
    @HostListener('window:resize')
    UpdatePosition() {
        if (!this.IsVisible || !this.triggerRef?.nativeElement) return;

        const r = this.triggerRef.nativeElement.getBoundingClientRect();
        const gap = 8;

        switch (this.Position) {
            case 'top':
                this.ContentStyle = { left: `${r.left + r.width / 2}px`, top: `${r.top - gap}px`, transform: 'translate(-50%, -100%)' };
                break;
            case 'left':
                this.ContentStyle = { left: `${r.left - gap}px`, top: `${r.top + r.height / 2}px`, transform: 'translate(-100%, -50%)' };
                break;
            case 'right':
                this.ContentStyle = { left: `${r.right + gap}px`, top: `${r.top + r.height / 2}px`, transform: 'translate(0, -50%)' };
                break;
            case 'bottom':
            default:
                this.ContentStyle = { left: `${r.left + r.width / 2}px`, top: `${r.bottom + gap}px`, transform: 'translate(-50%, 0)' };
                break;
        }
    }

    ngOnDestroy() {
        // Remover o popup portado para o body
        const el = this.tooltipRef?.nativeElement;
        if (el && el.parentElement === document.body) el.remove();
    }

}
